import { DocumentLanguage, TargetAudienceThingJson, BrandVoiceThingJson, Template } from "./article";
import { topicIdea } from "./topic";
import { LayoutColumnDefinition } from "./layout-content";
import { ContentOutlineSection } from "./content-outline";

export interface TopicIdeaPayloadForAIGenerationType {
  topicIdea: topicIdea;
  language: string;
  tone: string;
  contentBrief: string;
  gender: string;
  ageGroup: string;
  interestAndPersona: string;
  brandVoiceDocument: string;
  isOutlineCreation: boolean;
  isGenericFlow: boolean;
  templateId: number;
  templateTitle: string;
  inputText: string;
  titleText: string;
  placeholderText: string;
  contentBriefText: string;
  isPublishable: boolean;
  hideChangeWorkflow: boolean;
  geoRecommendationId?: string;
  knowledgeChunkData?: string ;
  isKnowledgeVaultEnable?: boolean;
  prompts?: string[];
}

export class TopicIdeaPayloadForAIGeneration {
  topicIdea: topicIdea = new topicIdea();
  language: string = "";
  // Sent with every generation so the template prompts can substitute {Intent} and {WordCount}.
  intent: string = "";
  wordCount: number = null;
  tone: string = "";
  contentBrief: string = "";
  // The Content Brief questions that produced the "$$" joined answers in contentBrief. The
  // outline prompt pairs them back up; an answer on its own is an unattributed fragment.
  contentBriefQuestions: string[] = [];
  // The plan reviewed on the Content Outline step - returned by generateContentOutline(), then
  // sent back with the final generation so the article follows what was approved. The two fields
  // below are the article level read that came back with it.
  contentOutline: ContentOutlineSection[] = [];
  contentOutlineTitle: string = "";
  contentOutlinePurpose: string = "";
  contentOutlineFormat: string = "";
  gender: string = "";
  ageGroup: string = "";
  interestAndPersona: string = "";
  brandVoiceDocument: string = "";
  targetAudienceDetails: TargetAudienceThingJson;
  brandVoiceDetails: BrandVoiceThingJson;
  isOutlineCreation: boolean = false;
  isGenericFlow: boolean = false;
  HighlightedTextOrCustomPrompt: string = "";
  isExpand: boolean = false;
  isParaphrase: boolean = false;
  isChangeVoice: boolean = false;
  isCustomCommand: boolean = false;
  languageDetail: DocumentLanguage;
  templateId: number;
  targetAudienceId: number;
  brandVoiceId: number;
  templateTitle: string;
  inputText: string;
  titleText: string;
  placeholderText: string;
  contentBriefText: string;
  isPublishable: boolean;
  hideChangeWorkflow: boolean;
  // Author picked in the Create New modal, carried through so the generated article opens on that
  // author rather than defaulting to whoever is signed in.
  authorName: string = "";
  recreateContentDocument: string = "";
  campaignGoal?: string = "";
  campaignTopic?: string = "";
  campaignId?: string = "";
  isFaqWorkflow:boolean = false;
  isCustomTemplateWorkflow:boolean = false;
  isYoutubeSummaryTemplateWorkflow:boolean = false;
  serviceName?: string = "";
  projectType?: string = "";
  contentOutlineGoal?: string = "";
  PageUrls: string[] = [];
  isParentUrl:boolean = false;
  isRegenerateRequest: boolean = false;
  isRegenerateFlow: boolean = false;
  isStreamFlow: boolean = false;
  geoRecommendationId?: string = null;
  knowledgeChunkData?: string = null;
  isKnowledgeVaultEnable: boolean = false;
  isInternalLinksEnable: boolean = false;
  prompts: string[] = [];
  // "Add A Layout" column generation - the preset the editor just inserted plus the
  // article context it landed in. See ArticleService.generateLayoutContent().
  isLayoutGeneration: boolean = false;
  layoutName?: string = "";
  layoutColumns?: LayoutColumnDefinition[] = [];
  articleTitle?: string = "";
  articleContext?: string = "";
  // Every template picked in the Select Templates step - one article is generated per entry.
  selectedTemplates: Template[] = [];
  // Existing article context for the Custom Command prompt, so the instruction is executed against
  // the article on screen instead of in isolation.
  metaTitle: string = "";
  metaDescription: string = "";
  keyphrase: string = "";
  articleBody: string = "";
}
